import { Fragment } from 'react';

import Dialog from 'components/Dialog';

import { ReactComponent as NoteIcon } from 'assets/info-icon.svg';

import rolesAndPermissions from './data';
import PermissionCell from './PermissionCell';

export interface MembersRolesAndPermissionsDialogProps {
  open: boolean;
  onClose: () => void;
}

const MembersRolesAndPermissionsDialog = ({ open, onClose }: MembersRolesAndPermissionsDialogProps) => {
  return (
    <Dialog
      variant='large'
      isOpen={open}
      onClose={onClose}
      title='Roles and Permissions'
      className='roles-and-permissions'
      classes={{
        body: 'roles-and-permissions__body',
      }}
    >
      <div className='note-wrapper'>
        <div className='note'>
          <NoteIcon className='note__icon' />
          <div className='note__text'>
            <div>
              For Acadly's purposes, "class" is used as a synonym for a lecture or a teaching session.
            </div>
            <div>A "course" is a collection of classes.</div>
          </div>
        </div>
      </div>
      <div className='roles-and-permissions__table-container'>
        <table className='table table--sticky'>
          <thead className='table__head'>
            <tr>
              <th className='table__cell table__cell--frozen'></th>
              <th className='table__cell' align='center'>
                Course Admin
              </th>
              <th className='table__cell' align='center'>
                Course Instructor
              </th>
              <th className='table__cell' align='center'>
                Course TA
              </th>
            </tr>
          </thead>
          <tbody className='table__body'>
            {rolesAndPermissions.map(({ group, actions }) => (
              <Fragment key={group}>
                <tr>
                  <th className='table__cell table__cell--frozen'>
                    {/*
                      position: sticky with colspan is not supported by browsers,
                      so, rendering without colspan and positioning text absolutely should give same behavior
                      only disadvantage is to render a fake div to have the desired space
                     */}
                    <div className='group'>
                      &nbsp;
                      <div className='group__name'>{group}</div>
                    </div>
                  </th>
                </tr>
                {actions.map(({ action, permissions: { admin, instructor, ta } }) => (
                  <tr key={action}>
                    <th className='table__cell table__cell--frozen table__cell--action-name'>{action}</th>
                    <PermissionCell permission={admin} />
                    <PermissionCell permission={instructor} />
                    <PermissionCell permission={ta} />
                  </tr>
                ))}
              </Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </Dialog>
  );
};

export default MembersRolesAndPermissionsDialog;
